import {
  SUPERSET_AIRPORT_VENDOR_LIST,
  SUPERSET_AIRPORT_VENDOR_LIST_SUCCESS,
  SUPERSET_AIRPORT_VENDOR_LIST_ERROR,
  SUPERSET_AIRPORT_VENDOR_LIST_EMPTY,
} from '../../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const SupersetAirportVendorList = (state = initialState, action) => {
  switch (action.type) {
    case SUPERSET_AIRPORT_VENDOR_LIST:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SUPERSET_AIRPORT_VENDOR_LIST_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case SUPERSET_AIRPORT_VENDOR_LIST_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SUPERSET_AIRPORT_VENDOR_LIST_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SupersetAirportVendorList;
